const search = (search) => {

    // const $search = $(search);
    //
    // if (!$search.length) return;
    //
    // $search.find('.js-search-icon').on('click', function () {
    //     $(this).toggleClass('active');
    //     $(this).parent().find('.js-search-wrap').toggleClass('active');
    // });
    //
    // $(document).on('click', function (e) {
    //     if ($search.has(e.target).length === 0) {
    //         $search.find('.js-search-input').removeClass('active');
    //     }
    // });
};

export default search;
